import { ChangeEvent } from "react";
import { styled } from "styled-components";
import injectFontFamily from "../../utils/injectFontFamily";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Header = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

interface FontSelectionProps {
  label: string;
  fontVariantName: string;
}

export default function FontSelection({
  label,
  fontVariantName,
}: FontSelectionProps) {
  async function handlePrimaryRegularChange(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) {
      try {
        await injectFontFamily(file, fontVariantName);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  }

  return (
    <Container>
      <Header>{label}</Header>
      <input
        type="file"
        accept=".ttf,.otf"
        onChange={handlePrimaryRegularChange}
      />
    </Container>
  );
}
